import React from 'react'
import { useDropzone } from 'react-dropzone'
import Loader from '@byma/shared/components/Loader'
import useAuth from '@byma/shared/hooks/useAuth'

const MAX_FILE_SIZE = 1 * 1024 * 1024 // 1MB

export default function Upload({ onChange }) {
    const { token } = useAuth()
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(null)

    async function onDrop(acceptedFiles) {
        setError(null)
        acceptedFiles.forEach(async (file) => {
            setLoading(true)
            const formData = new FormData()

            formData.append('file', file);
            formData.append('upload_preset', 'd9fee5bb')

            try {
                const req = await fetch('https://api.cloudinary.com/v1_1/htkavmx5a/image/upload', {
                    method: 'POST',
                    body:formData
                })
                const img = await req.json()
                onChange(img.secure_url)
            } catch (e) {
                console.log(e)
                console.log('Erro ao realizar upload do arquivo')
            }

            setLoading(false)
        })
    }

    function onDropRejected(fileRejections) {
        const rejection = fileRejections[0]
        if (rejection?.errors?.some(e => e.code === 'file-too-large')) {
            setError('O arquivo deve ter no máximo 1MB')
        }
    }

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        onDrop,
        onDropRejected,
        accept: 'image/*',
        maxSize: MAX_FILE_SIZE,
    })


    return (
        <div {...getRootProps({className: 'dropzone focus:outline-none outline-none flex flex-col space-y-2'})}>
            {loading ? <Loader /> : (
                <div className="border-dashed border-2 dark:border-gray-400 p-6 text-center text-gray-700 dark:text-gray-200 w-full items-center justify-center flex flex-col">
                    <input {...getInputProps()} className="outline-none focus:outline-none" />
                    <p>Clique ou arraste aqui uma imagem para enviar</p>
                    <p className="text-xs text-gray-500 mt-1">Tamanho máximo: 1MB</p>
                </div>
            )}
            {error && (
                <p className="text-sm text-red-600">{error}</p>
            )}
        </div>
    )
}
